import { useMutation } from '@apollo/client'
import {
  PATCH_WORK_PERIOD,
  TRANSFER_OVERTIME_TO_ABSENCE_HOUR_TRANSACTION,
} from '../mutations'
import { useOnErrorAuto } from '@/utils'
import { useToast } from '@ur-solutions/react-components'
import { useTranslate } from '@ur-solutions/react-hooks'

export const useWorkPeriodMigrations = () => {
  const translations = useTranslate({
    couldNotTransferOvertime: 'salary.could-not-transfer-overtime',
    overtimeRemovedFromFlex: 'salary.overtime-removed-from-flextime',
    overtimeTransferredToFlex: 'salary.overtime-transferred-to-flextime',
  })
  const onErrorAuto = useOnErrorAuto()
  const addToast = useToast()

  const [patchWorkPeriod] = useMutation(PATCH_WORK_PERIOD, {
    onError: onErrorAuto(),
  })

  const [transferOvertimeToFlex, { loading }] = useMutation(
    TRANSFER_OVERTIME_TO_ABSENCE_HOUR_TRANSACTION,
    {
      onError: onErrorAuto(),
      update(cache, { data }) {
        const workPeriod =
          data?.transferOvertimeWorkToAbsenceHourTransaction?.workPeriod
        if (!workPeriod) return

        cache.modify({
          id: cache.identify(workPeriod),
          fields: {
            absenceHourTransaction: () => workPeriod.absenceHourTransaction,
          },
        })
      },
      onCompleted(data) {
        if (!data.transferOvertimeWorkToAbsenceHourTransaction.success) {
          addToast('info', translations.couldNotTransferOvertime)
          return
        }

        addToast(
          'success',
          data.transferOvertimeWorkToAbsenceHourTransaction.workPeriod
            ?.absenceHourTransaction
            ? translations.overtimeTransferredToFlex
            : translations.overtimeRemovedFromFlex
        )
      },
    }
  )
  return {
    patchWorkPeriod,
    transferOvertimeToFlex,
    loading,
  }
}
